import Event from "../../event/event"
import {getEventIconClass} from "../../event/functions/event-icon"
import Goal from "../goal"
import ModelProxy from "../../model-proxy"
import {EventType} from "../../../gd/const/event"

const MAX_VALUE = 100

const debug = false
// const debug = "GoalEvent"

export default class GoalEvent extends Goal {

    public event        : Event

    constructor(data: any, useProxy = true) {
        super(data, false)

        this.event          = new Event(data['event'] || {})

        this.targetValue    = MAX_VALUE

        return useProxy ? new Proxy(this, ModelProxy) : this
    }

    openGoal() {
        gd.navigation.goToEvent(this.event.id)
    }

    get noEntity() {
        return !this.event.id
    }

    get name() {
        return this.event.name
    }

    set name(value: string) {
        this.event.name = value
    }

    get icon() {
        return getEventIconClass(this.event) || 'ii5-milestone'
    }

    get startDate(): MomentDate | null {
        return this.event?.startDate as MomentDate || null
    }

    set startDate(value: MomentDate | null) {
        const startDate = value
        let endDate

        debug && console.log(debug, 'startDate', value)

        switch (this.event.type) {
            case EventType.PROJECT_MILESTONE:
                endDate = startDate
                break

            default                         :
                if (startDate && (!this.endDate || startDate?.isAfter(this.endDate, 'day'))) {
                    endDate = startDate.clone() as MomentDate
                }
                break
        }


        if (!startDate) {
            endDate = null
        }

        this.event.startDate = startDate

        if (!_.isUndefined(endDate)) {
            this.event.endDate = endDate
        }
    }

    get endDate(): MomentDate | null {
        return this.event?.endDate as MomentDate || null
    }

    set endDate(value: MomentDate | null) {
        const endDate = value
        let startDate

        debug && console.log(debug, 'endDate', value)

        switch (this.event.type) {
            case EventType.PROJECT_MILESTONE:
                startDate = endDate
                break

            default                         :
                if (this.startDate && endDate?.isBefore(this.startDate, 'day')) {
                    startDate = endDate.clone() as MomentDate
                }
                break
        }

        if (!endDate) {
            startDate = null
        }

        this.event.endDate = endDate

        if (!_.isUndefined(startDate)) {
            this.event.startDate = startDate
        }
    }

    get startEnd() {
        return this.startDue
    }

    get assigneeUserIds(): ID[] | null {
        switch(this.event.type) {
            case EventType.PROJECT_MILESTONE: return this.event.assignedToUserId ? [this.event.assignedToUserId] : []
            default                         : return super.assigneeUserIds
        }
    }

    set assigneeUserIds(values: ID[] | null) {
        switch(this.event.type) {
            case EventType.PROJECT_MILESTONE:
                // set last selected userId if any
                this.event.assignedToUserId = !_.isNil(values) && !_.isEmpty(values) ? values[values?.length - 1] : null
                break

            default                         : super.assigneeUserIds = values
        }
    }

    get duration():number | null {
        return this.event.durationCalendar
    }

    set duration(value:number | null) {
        this.event.durationCalendar = value
    }

    get durationWorkdays():number | null {
        return this.event.durationWorkdays
    }

    set durationWorkdays(value:number | null) {
        this.event.durationWorkdays = value
    }

    get progress(): number {
        return this.event.isAccomplished ? MAX_VALUE : 0
    }

    get isDone(): boolean {
        return this.event.isAccomplished
    }

    set isDone(value:boolean) {
        this.event.isAccomplished = value
    }

    /*get health(): number {
        return this._health;
    }

    set health(value: number) {
        this._health = value
    }*/

    applyDelta(data:any) {
        let isChanged = super.applyDelta(data, ['event'])

        if (data.event) {
            this.event = new Event(data.event)
            isChanged = true
        }

        return isChanged
    }

    async save(): Promise<void> {
        await super.save()

        this.event.save()
    }

    toJSON(): any {
        const json: any = super.toJSON()

        json.event      = this.event.toJSON()

        return json
    }
}
